module.exports = __webpack_public_path__ + "img/primary_2x2.61761dec.svg";